import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../common';
import { FormsModule } from '@angular/forms';
import { ConnectGatewayWizard } from './wizards/connect-gateway/connect-gateway.wizard';
import { ConnectNetworkDialog } from './dialog/connect-network/connect-network.component';

import { DisconnectGatewayDialog } from './dialog/connect-network/disconnect-gateway.component';

import { EditGatewayWizard } from './wizards/edit-gateway/edit-gateway.wizard';
import { SelectGateway } from './wizards/connect-gateway/steps/select-gateway.component';
import { ConfigureGateway } from './wizards/connect-gateway/steps/configure-gateway.component';
import { ManageUplink } from './wizards/connect-gateway/steps/manage-uplink.component';
import { DirectConnectNetworksCreated } from './wizards/connect-gateway/steps/dc-networks-created.component';
import { DirectConnectNetworksNew } from './wizards/connect-gateway/steps/dc-networks-new.component';
import { ReadyToCompleteCreate } from './wizards/connect-gateway/steps/rtoc-create.component';

import { TranslateModule } from '@ngx-translate/core';

import { EditConfigureGateway } from './wizards/edit-gateway/steps/edit-configure-gateway.component';
import { EditManageUplink } from './wizards/edit-gateway/steps/edit-manage-uplink.component';
import { EditReadyToComplete } from './wizards/edit-gateway/steps/edit-rtoc.component';
import { RefreshSharedService } from '../../../refresh-shared-service';

@NgModule({
    imports: [
        CommonModule,
        ClarityModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule

    ],
    declarations: [
        ConnectGatewayWizard,
        ConnectNetworkDialog,
        DisconnectGatewayDialog,
        EditGatewayWizard,
        SelectGateway,
        ConfigureGateway,
        ManageUplink,
        DirectConnectNetworksCreated,
        DirectConnectNetworksNew,
        ReadyToCompleteCreate,
        EditConfigureGateway,
        EditManageUplink,
        EditReadyToComplete

    ],
     providers: [
       RefreshSharedService
    ],
    exports: [
        ConnectGatewayWizard,
        ConnectNetworkDialog,
        DisconnectGatewayDialog,
        EditGatewayWizard,
        SelectGateway,
        ConfigureGateway,
        ManageUplink,
        DirectConnectNetworksCreated,
        DirectConnectNetworksNew,
        ReadyToCompleteCreate,
        EditConfigureGateway,
        EditManageUplink,
        EditReadyToComplete

       ]
})
export  class DirectConnectModule {
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/direct-connect.module.ts